export default "__VITE_ASSET__DIywgVKT__"